import React from "react";

import IconButton from "@mui/material/IconButton";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function CampanhaOfertasCliente({
  ofertasCliente,
  alternativasOfertasCliente,
  abrirNovaOfertaCliente,
  abrirEditarOfertaCliente,
  apagarOfertaCliente,
  abrirNovaAlternativaOfertaCliente,
  abrirEditarAlternativaOfertaCliente,
  apagarAlternativaOfertaCliente,
}) {
  return (
    <MDBox
      mt={2}
      p={{ xs: 1.25, md: 2 }}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
        mb={2}
        sx={{
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDTypography variant="h6">Ofertas ao cliente</MDTypography>

        <MDButton color="success" onClick={abrirNovaOfertaCliente}>
          Nova oferta
        </MDButton>
      </MDBox>

      <MDBox
        sx={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            minWidth: 850,
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Ref.</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material oferta</th>
              <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
              <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
              <th style={{ width: 120 }} />
            </tr>
          </thead>

          <tbody>
            {ofertasCliente.map((o) => {
              const alternativas = alternativasOfertasCliente[o.id] || [];

              return (
                <React.Fragment key={o.id}>
                  <tr>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {o.refmaterialoferta}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {o.materialoferta}
                    </td>

                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {o.qtd}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {o.unidade}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {o.obs}
                    </td>

                    <td style={{ borderTop: "1px solid #eee", whiteSpace: "nowrap" }}>
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => abrirEditarOfertaCliente(o)}
                        title="Editar oferta"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => apagarOfertaCliente(o)}
                        title="Eliminar oferta"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>

                      <MDButton
                        color="info"
                        size="small"
                        onClick={() => abrirNovaAlternativaOfertaCliente(o)}
                        style={{ marginLeft: 4 }}
                      >
                        Nova alt.
                      </MDButton>
                    </td>
                  </tr>

                  {alternativas.map((a) => (
                    <tr key={`alt-oferta-${a.id}`}>
                      <td />

                      <td
                        colSpan={4}
                        style={{
                          fontSize: 12,
                          padding: "5px 6px 5px 24px",
                          color: "#6c757d",
                          borderTop: "1px dashed #eee",
                          background: "#fafafa",
                        }}
                      >
                        ↳ {a.refmaterialalternativo} — {a.materialalternativo} | Qtd: {a.qtd}{" "}
                        {a.unidade || ""}
                        {a.obs ? ` | ${a.obs}` : ""}
                      </td>

                      <td
                        style={{
                          borderTop: "1px dashed #eee",
                          background: "#fafafa",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => abrirEditarAlternativaOfertaCliente(o, a)}
                          title="Editar alternativa"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => apagarAlternativaOfertaCliente(a)}
                          title="Eliminar alternativa"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </MDBox>
    </MDBox>
  );
}
